"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerSigningStargateClient = void 0;
var encoding_1 = require("@cosmjs/encoding");
var tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
var accounts_1 = require("./accounts");
var stargateclient_1 = require("./stargateclient");
var axios_1 = __importDefault(require("axios"));
var any_1 = require("../google/protobuf/any");
var LedgerSigningStargateClient = /** @class */ (function (_super) {
    __extends(LedgerSigningStargateClient, _super);
    function LedgerSigningStargateClient(tmClient) {
        return _super.call(this, tmClient) || this;
    }
    LedgerSigningStargateClient.connectWithSigner = function (endpoint) {
        return __awaiter(this, void 0, void 0, function () {
            var tmClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._endpoint = endpoint;
                        return [4 /*yield*/, tendermint_rpc_1.Tendermint34Client.connect(endpoint)];
                    case 1:
                        tmClient = _a.sent();
                        return [2 /*return*/, new LedgerSigningStargateClient(tmClient)];
                }
            });
        });
    };
    LedgerSigningStargateClient.prototype.getSignerData = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var chainID, account;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChainId()];
                    case 1:
                        chainID = _a.sent();
                        return [4 /*yield*/, this.getAccount(address)];
                    case 2:
                        account = _a.sent();
                        if (account == null)
                            throw new Error("account is null");
                        return [2 /*return*/, { account_number: account.accountNumber.toString(), sequence: account.sequence.toString(), chain_id: chainID }];
                }
            });
        });
    };
    LedgerSigningStargateClient.prototype.getChainId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, chainId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.chainId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.forceGetTmClient().status()];
                    case 1:
                        response = _a.sent();
                        chainId = response.nodeInfo.network;
                        if (!chainId)
                            throw new Error("Chain ID must not be empty");
                        this.chainId = chainId;
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.chainId];
                }
            });
        });
    };
    /**
   * Takes a bech32 encoded address and returns the data part. The prefix is ignored and discarded.
   * This is called AccAddress in Cosmos SDK, which is basically an alias for raw binary data.
   * The result is typically 20 bytes long but not restricted to that.
   */
    LedgerSigningStargateClient.prototype.toAccAddress = function (address) {
        return encoding_1.Bech32.decode(address).data;
    };
    LedgerSigningStargateClient.prototype.getAccount = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var accAddress, hexAccAddress, axios, path, result, finalData, account, finalAccount, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        accAddress = this.toAccAddress(address);
                        hexAccAddress = "0x01" + Buffer.from(accAddress).toString("hex");
                        axios = axios_1.default.create({
                            baseURL: LedgerSigningStargateClient._endpoint,
                            headers: {
                                Accept: "application/json",
                            },
                            timeout: 15000
                        });
                        path = "/abci_query?path=\"/store/acc/key\"";
                        return [4 /*yield*/, axios.get(path, { params: { data: hexAccAddress } })];
                    case 1:
                        result = _a.sent();
                        finalData = result.data.result.response.value;
                        account = any_1.Any.decode(Buffer.from(finalData, "base64"));
                        finalAccount = accounts_1.accountFromAny(account);
                        return [2 /*return*/, finalAccount];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LedgerSigningStargateClient._endpoint = "";
    return LedgerSigningStargateClient;
}(stargateclient_1.StargateClient));
exports.LedgerSigningStargateClient = LedgerSigningStargateClient;
